import pc from '@/js/pc'

class Player {
    constructor(params) {
        this.params = params
        this.current_index = 0
        this.has_source_list = false

        this.state_filter = []
        this.player = this.buildPlayer()
    }

    on(state, callback) {
        if (this.state_filter.indexOf(state) == -1) {
            this.player.on(state, callback)
        }
    }

    play(canPlayFunc) {
        if (canPlayFunc) {
            canPlayFunc().then((can_play) => {
                can_play && this.player.play()
            })
        } else {
            this.player.play()
        }
    }

    pause(canPauseFunc) {
        if (canPauseFunc) {
            canPauseFunc().then((can_pause) => {
                can_pause && this.player.play()
            })
        } else {
            this.player.play()
        }
    }

    dispose() {
        this.player.dispose()
    }

    playNext() {
        const {
            source,
            change
        } = this.params
        if (this.has_source_list && (this.current_index + 1) < source.length) {
            this.current_index++
            const has_next = (this.current_index + 1) < source.length
            const switch_component = this.player.getComponent('PlaySwitchComponent')
            switch_component && switch_component.setTitle(source[this.current_index].title, true, has_next)
            $('.prism-thumbnail').hide()
            this.player.seek(0)
            this.player.loadByUrl(source[this.current_index].url)
            const tip_component = this.player.getComponent('PlayNextTipComponent')
            tip_component && tip_component.setNextText(has_next ? source[this.current_index + 1].title : '')
            change && change(this.current_index)
        } else {
            console.log('the last one')
        }
    }

    playPrev() {
        const {
            source,
            change
        } = this.params
        if (this.has_source_list && this.current_index > 0) {
            this.current_index--
            const has_perv = this.current_index != 0
            const switch_component = this.player.getComponent('PlaySwitchComponent')
            switch_component && switch_component.setTitle(source[this.current_index].title, has_perv, true)
            $('.prism-thumbnail').hide()
            this.player.seek(0)
            this.player.loadByUrl(source[this.current_index].url)
            const tip_component = this.player.getComponent('PlayNextTipComponent')
            tip_component && tip_component.setNextText(source[this.current_index + 1].title)
            change && change(this.current_index)
        } else {
            console.log('the first one')
        }
    }

    buildPlayer() {
        const {
            id = 'J_prismPlayer', source, autoplay = false, cover, components, isLive = false
        } = this.params

        let current_source = source
        this.has_source_list = Object.prototype.toString.call(source) == '[object Array]'
        if (this.has_source_list && source.length > 0) {
            this.current_index = 0
            current_source = source[0].url
        }

        return new Aliplayer({
            id,
            autoplay: false,
            cover,
            isLive,
            source: current_source,
            components,
            width: '100%',
            height: '100%',
            playsinline: true,
            preload: false,
            x5_type: 'h5',
            showBarTime: 5000,
            controlBarVisibility: pc.isPC() ? 'hover' : 'click',
        }, (player) => {
            setTimeout(() => {
                if (this.has_source_list) {
                    const has_next = (this.current_index + 1) < source.length
                    if (has_next) {
                        const tip_component = player.getComponent('PlayNextTipComponent')
                        tip_component && tip_component.setNextText(source[this.current_index + 1].title)
                    }

                    const switch_component = this.player.getComponent('PlaySwitchComponent')
                    switch_component && switch_component.setTitle(source[this.current_index].title, false, has_next)
                }

                // player.play()
                // const play_btn = document.querySelector('.prism-player .prism-big-play-btn')
                // if (!play_btn) return
                // play_btn.style.left = '50%'
                // play_btn.style.top = '50%'
                // play_btn.style.marginLeft = '-32px'
                // play_btn.style.marginTop = '-32px'
                // play_btn.style.display = 'none'

                components && components.map(component => player.getComponent(component.name).setSource && player.getComponent(component.name).setSource(this))
            }, 0)
        })
    }

    rebuildPlayer() {
        this.dispose()
        this.current_index = 0
        this.has_source_list = false
        this.state_filter = []
        this.player = this.buildPlayer()
    }
}


export default Player